var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1702 9.07238L18.159 7.15827L20 6.12812L9.97254 0.839844L0 6.23388L3.99826 8.52948L4.00623 9.89353L4.00705 10.0025L4.04358 9.98497C4.00143 10.0422 3.97442 10.101 3.97523 10.1598C3.97841 10.8307 6.68657 11.3616 10.0291 11.3434C13.37 11.3259 16.0742 10.764 16.0718 10.0946C16.0718 10.0358 16.0408 9.97863 15.9995 9.91981L16.036 9.9373V9.82836L16.0288 8.45878L17.7625 7.38013L17.772 9.07482C17.5812 9.15667 17.4485 9.34428 17.4501 9.5637C17.4517 9.85147 17.6854 10.0843 17.9755 10.082C18.2672 10.0803 18.4985 9.84504 18.4969 9.55809C18.4953 9.33867 18.3618 9.15268 18.1702 9.07238ZM10.0266 10.8815C7.06098 10.8982 4.65563 10.5723 4.65327 10.1566C4.65091 9.7409 7.05301 9.39196 10.0188 9.37682C12.9852 9.36014 15.3898 9.68444 15.3914 10.0994C15.3937 10.5136 12.9931 10.8657 10.0266 10.8815ZM15.8921 7.34751C15.4907 6.92542 14.0519 5.81098 9.99963 5.83409C5.94174 5.85557 4.52131 6.98351 4.12469 7.41194L4.12233 7.00816C4.12233 7.00816 5.2733 5.25701 9.99654 5.23236C14.7173 5.2069 15.8898 6.94454 15.8898 6.94454L15.8921 7.34751ZM17.5534 10.1963L17.3491 13.1605C17.981 12.1676 18.5089 12.5373 18.5089 12.5373L18.4962 10.1915C17.8172 10.4579 17.5534 10.1963 17.5534 10.1963Z",
    fill: "#773DD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademy);
export default __webpack_public_path__ + "static/media/academy.c28a219c1596a2a02b3650d44d96ed94.svg";
export { ForwardRef as ReactComponent };